export const FunnelVersion = {
  default: 'optimized-funnel',
  includes: (version: string | string[] | null | undefined): boolean => {
    if (!version || (!Array.isArray(version) && typeof version !== 'string')) {
      return false;
    }

    const versions = Array.isArray(version) ? version : [version];

    return versions.some((v) => Object.values(FunnelVersion).includes(v));
  },
  optimizedFunnel: 'optimized-funnel',
  v0085: '0085',
  v0090: '0090',
};
